// src/components/Snackbar.jsx
import React, { useEffect } from 'react';
import './Snackbar.css';

export const Snackbar = ({ message, onClose, duration = 4000 }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, duration);
    return () => clearTimeout(timer);
  }, [duration, onClose]);

  return (
    <div className="snackbar-overlay">
      <div className="snackbar-content">
        {message}
      </div>
    </div>
  );
};